import {eq, isNull} from '@shared/helpers/lang'
import {createStateMaker} from '@shared/helpers/object'

import {CandidateStatus, PayLaterMemberStatus} from '@web/core/constants'

import {PayLaterInfoStatus, PayLaterState, PayLaterUserInfo} from './interfaces'

export const getInitialState = (): PayLaterState => ({
    memberStatus: PayLaterMemberStatus.PENDING,
    payDue: null,
    payDueDate: '',
    availableAmount: 0,
    usingAmount: 0,
    useAll: false,
    enabled: false,
    overdue: null,
    userInfo: {
        maskedNaverId: null,
        isTestGroup: false,
    },
    signUpStatus: null,
    payDueValid: null,
    candidateStatus: CandidateStatus.DISABLED,
    status: null,
})

export const makeMock = createStateMaker<PayLaterState>(getInitialState)

export const getStatus = (payLaterUserInfo: PayLaterUserInfo, payable: boolean) => {
    const {isUserCandidate, isActiveUser, userStatus} = payLaterUserInfo

    if (!isUserCandidate && !isActiveUser) {
        return PayLaterMemberStatus.NOT_AVAILABLE
    }
    if (!isActiveUser) {
        return PayLaterMemberStatus.SIGNUP
    }
    if (!payable) {
        return PayLaterMemberStatus.MAINTENANCE
    }

    const eqStatus = eq(userStatus)

    if (eqStatus(PayLaterMemberStatus.NORMAL)) {
        return PayLaterMemberStatus.NORMAL
    } else if (eqStatus(PayLaterMemberStatus.SUSPENDED)) {
        return PayLaterMemberStatus.SUSPENDED
    } else if (eqStatus(PayLaterMemberStatus.OVERDUE)) {
        return PayLaterMemberStatus.OVERDUE
    }

    return PayLaterMemberStatus.NOT_AVAILABLE
}

export const getPayLaterState = ({
    originState,
    payLaterUserInfo,
    payable,
}: {
    originState: PayLaterState
    payLaterUserInfo: PayLaterUserInfo
    payable: boolean
}) => {
    if (!payLaterUserInfo) {
        return {
            ...originState,
            memberStatus: PayLaterMemberStatus.NOT_AVAILABLE,
            status: PayLaterInfoStatus.COMPLETED,
        }
    }

    if (!payable) {
        return {
            ...originState,
            memberStatus: PayLaterMemberStatus.MAINTENANCE,
            status: PayLaterInfoStatus.COMPLETED,
        }
    }

    const overdue = !isNull(payLaterUserInfo.overduePenaltyStatus)
        ? {
              amount: (payLaterUserInfo.overdueFee ?? 0) + (payLaterUserInfo.redemptionAmount ?? 0),
              penaltyStatus: payLaterUserInfo.overduePenaltyStatus,
          }
        : null

    return {
        ...originState,
        enabled: originState.enabled && payable && eq(payLaterUserInfo?.userStatus, PayLaterMemberStatus.NORMAL),
        memberStatus: getStatus(payLaterUserInfo, payable),
        payDue: payLaterUserInfo.payDue,
        payDueDate: payLaterUserInfo.payDueDate ?? '',
        availableAmount: payLaterUserInfo.availableAmount ?? 0,
        overdue,
        userInfo: {
            isTestGroup: payLaterUserInfo.isTestGroupUser,
            maskedNaverId: payLaterUserInfo.naverId,
        },
        candidateStatus: payLaterUserInfo.isUserCandidate ? CandidateStatus.CANDIDATE : CandidateStatus.NOT_CANDIDATE,
        status: PayLaterInfoStatus.COMPLETED,
    }
}
